import { Outlet } from 'react-router';

export const PartnerManagerLayout = () => <Outlet />;
